/**
 * A collection's membership is applied by the search endpoint, from `?collection=<slug>`. The
 * client only ever holds the user's own narrowing within it.
 */
import { Paths } from "client/routes";
import { SelectedProductFilters } from "client/products/types";
import { getProductFiltersFromSearch } from "client/products/utils";

type CollectionSearch = Paths["productCollections"]["detail"]["Search"];

const noSelectedFilters = (): SelectedProductFilters => ({
  category_ids: [],
  manufacturer_ids: [],
  species: [],
  prescription_required: [],
});

export const SEARCH_DEFAULTS = {
  q: "",
  page: 1,
  page_size: 20,
  sort: "",
  ...noSelectedFilters(),
};

/**
 * The user's filters from the URL, narrowed to the four the UI offers. A spread would let a
 * filter with no control narrow the grid invisibly.
 */
export const getSelectedFilters = (
  search: CollectionSearch,
  showFilters: boolean,
): SelectedProductFilters => {
  if (!showFilters) {
    return noSelectedFilters();
  }
  const parsed = getProductFiltersFromSearch(search);
  return {
    category_ids: parsed.category_ids,
    manufacturer_ids: parsed.manufacturer_ids,
    species: parsed.species,
    prescription_required: parsed.prescription_required,
  };
};

export const hasAnyFilterValue = (filters: SelectedProductFilters) =>
  filters.category_ids.length > 0 ||
  filters.manufacturer_ids.length > 0 ||
  filters.species.length > 0 ||
  filters.prescription_required.length > 0;
